import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const WHATSAPP = process.env.REACT_APP_WHATSAPP_NUMBER || "+971000000000";
export const CALENDLY = process.env.REACT_APP_CALENDLY_URL || "https://calendly.com/tratouenergy";

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? localStorage.getItem("tratou_admin_token") : null;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
};
